// src/pages/AppRoutes.tsx - БЕЗ diary, фикс именованных/дефолтных импортов

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

// ✅ Эти два компонента экспортируются ИМЕНОВАННО
import { WelcomePage } from './WelcomePage/WelcomePage';
import { QuestionnairePage } from './QuestionnairePage/QuestionnairePage';

// ✅ Эти страницы экспортируются по умолчанию
import CalendarPage from './CalendarPage/CalendarPage';
import ProfilePage from './ProfilePage/ProfilePage';
import AchievementsPage from './AchievementsPage/AchievementsPage';

import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import { useAuthStore } from '../store/authStore';

export const AppRoutes: React.FC = () => {
  const { questionnaireCompleted } = useAuthStore();

  if (process.env.NODE_ENV === 'development') {
    console.log('🔄 AppRoutes: questionnaireCompleted =', questionnaireCompleted);
  }

  return (
    <AnimatePresence mode="wait">
      <Routes>
        {/* 🏠 Главная - редирект на welcome или calendar */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              {questionnaireCompleted ? (
                <Navigate to="/calendar" replace />
              ) : (
                <Navigate to="/welcome" replace />
              )}
            </ProtectedRoute>
          }
        />

        {/* 👋 Приветственный экран */}
        <Route
          path="/welcome"
          element={
            <ProtectedRoute>
              {questionnaireCompleted ? (
                <Navigate to="/calendar" replace />
              ) : (
                <WelcomePage />
              )}
            </ProtectedRoute>
          }
        />

        {/* 📋 Анкета */}
        <Route
          path="/questionnaire"
          element={
            <ProtectedRoute>
              {questionnaireCompleted ? (
                <Navigate to="/calendar" replace />
              ) : (
                <QuestionnairePage />
              )}
            </ProtectedRoute>
          }
        />

        {/* 📅 Календарь */}
        <Route
          path="/calendar"
          element={
            <ProtectedRoute>
              {questionnaireCompleted ? (
                <CalendarPage />
              ) : (
                <Navigate to="/welcome" replace />
              )}
            </ProtectedRoute>
          }
        />

        {/* 🏆 Достижения */}
        <Route
          path="/achievements"
          element={
            <ProtectedRoute>
              {questionnaireCompleted ? (
                <AchievementsPage />
              ) : (
                <Navigate to="/welcome" replace />
              )}
            </ProtectedRoute>
          }
        />

        {/* 👤 Профиль */}
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              {questionnaireCompleted ? (
                <ProfilePage />
              ) : (
                <Navigate to="/welcome" replace />
              )}
            </ProtectedRoute>
          }
        />

        {/* Fallback */}
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <Navigate to="/" replace />
            </ProtectedRoute>
          }
        />
      </Routes>
    </AnimatePresence>
  );
};
